import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="baseuievent" id="baseuievent"></a>
    <h1 {...{
      "id": "windowbaseuievent"
    }}>{`window.BaseUIEvent`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/UIEvent"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/UIEvent`}</a>{`  `}</p>
    <a name="new-baseuievent-new" id="new-baseuievent-new"></a>
    <h2 {...{
      "id": "baseuieventtype-eventinit"
    }}>{`BaseUIEvent(type, eventInit)`}</h2>
    <p>{`Creates an instance of BaseUIEvent.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventInit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="baseuievent-pointerid" id="baseuievent-pointerid"></a>
    <h2 {...{
      "id": "pointerid"
    }}>{`pointerId`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-width" id="baseuievent-width"></a>
    <h2 {...{
      "id": "width--number"
    }}>{`width : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-height" id="baseuievent-height"></a>
    <h2 {...{
      "id": "height--number"
    }}>{`height : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-pressure" id="baseuievent-pressure"></a>
    <h2 {...{
      "id": "pressure--number"
    }}>{`pressure : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-tangentialpressure" id="baseuievent-tangentialpressure"></a>
    <h2 {...{
      "id": "tangentialpressure--number"
    }}>{`tangentialPressure : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-tiltx" id="baseuievent-tiltx"></a>
    <h2 {...{
      "id": "tiltx--number"
    }}>{`tiltX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-tilty" id="baseuievent-tilty"></a>
    <h2 {...{
      "id": "tilty--number"
    }}>{`tiltY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-twist" id="baseuievent-twist"></a>
    <h2 {...{
      "id": "twist--number"
    }}>{`twist : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-clientx" id="baseuievent-clientx"></a>
    <h2 {...{
      "id": "clientx--number"
    }}>{`clientX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-clienty" id="baseuievent-clienty"></a>
    <h2 {...{
      "id": "clienty--number"
    }}>{`clientY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-offsetx" id="baseuievent-offsetx"></a>
    <h2 {...{
      "id": "offsetx--number"
    }}>{`offsetX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-offsety" id="baseuievent-offsety"></a>
    <h2 {...{
      "id": "offsety--number"
    }}>{`offsetY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-pagex" id="baseuievent-pagex"></a>
    <h2 {...{
      "id": "pagex--number"
    }}>{`pageX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-pagey" id="baseuievent-pagey"></a>
    <h2 {...{
      "id": "pagey--number"
    }}>{`pageY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-screenx" id="baseuievent-screenx"></a>
    <h2 {...{
      "id": "screenx--number"
    }}>{`screenX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-screeny" id="baseuievent-screeny"></a>
    <h2 {...{
      "id": "screeny--number"
    }}>{`screenY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-movementx" id="baseuievent-movementx"></a>
    <h2 {...{
      "id": "movementx--number"
    }}>{`movementX : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-movementy" id="baseuievent-movementy"></a>
    <h2 {...{
      "id": "movementy--number"
    }}>{`movementY : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-button" id="baseuievent-button"></a>
    <h2 {...{
      "id": "button--number"
    }}>{`button : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-buttons" id="baseuievent-buttons"></a>
    <h2 {...{
      "id": "buttons"
    }}>{`buttons`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-detail" id="baseuievent-detail"></a>
    <h2 {...{
      "id": "detail"
    }}>{`detail`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-pointertype" id="baseuievent-pointertype"></a>
    <h2 {...{
      "id": "pointertype"
    }}>{`pointerType`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-altkey" id="baseuievent-altkey"></a>
    <h2 {...{
      "id": "altkey"
    }}>{`altKey`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-shiftkey" id="baseuievent-shiftkey"></a>
    <h2 {...{
      "id": "shiftkey"
    }}>{`shiftKey`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-metakey" id="baseuievent-metakey"></a>
    <h2 {...{
      "id": "metakey"
    }}>{`metaKey`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-ctrlkey" id="baseuievent-ctrlkey"></a>
    <h2 {...{
      "id": "ctrlkey"
    }}>{`ctrlKey`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-isprimary" id="baseuievent-isprimary"></a>
    <h2 {...{
      "id": "isprimary"
    }}>{`isPrimary`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="baseuievent-which" id="baseuievent-which"></a>
    <h2 {...{
      "id": "which"
    }}>{`which`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-type" id="event-type"></a>
    <h2 {...{
      "id": "type"
    }}>{`type`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-istrusted" id="event-istrusted"></a>
    <h2 {...{
      "id": "istrusted--boolean"
    }}>{`isTrusted : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-target" id="event-target"></a>
    <h2 {...{
      "id": "target--node"
    }}>{`target : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-currenttarget" id="event-currenttarget"></a>
    <h2 {...{
      "id": "currenttarget--node"
    }}>{`currentTarget : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-bubbles" id="event-bubbles"></a>
    <h2 {...{
      "id": "bubbles--boolean"
    }}>{`bubbles : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-cancelable" id="event-cancelable"></a>
    <h2 {...{
      "id": "cancelable--boolean"
    }}>{`cancelable : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-composed" id="event-composed"></a>
    <h2 {...{
      "id": "composed--boolean"
    }}>{`composed : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-eventphase" id="event-eventphase"></a>
    <h2 {...{
      "id": "eventphase"
    }}>{`eventPhase`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-defaultprevented" id="event-defaultprevented"></a>
    <h2 {...{
      "id": "defaultprevented--boolean"
    }}>{`defaultPrevented : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-returnvalue" id="event-returnvalue"></a>
    <h2 {...{
      "id": "returnvalue--"
    }}>{`returnValue : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="event-initevent" id="event-initevent"></a>
    <h2 {...{
      "id": "initeventtypearg-bubblesarg-cancelablearg"
    }}>{`initEvent(typeArg, bubblesArg, cancelableArg)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`typeArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`bubblesArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cancelableArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="event-composedpath" id="event-composedpath"></a>
    <h2 {...{
      "id": "composedpath"
    }}>{`composedPath()`}</h2>
    <p>{`Returns the event's path`}</p>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath"
        }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://dom.spec.whatwg.org/#dom-event-composedpath"
        }}>{`https://dom.spec.whatwg.org/#dom-event-composedpath`}</a></li>
    </ul>
    <a name="event-preventdefault" id="event-preventdefault"></a>
    <h2 {...{
      "id": "preventdefault"
    }}>{`preventDefault()`}</h2>
    <a name="event-stopimmediatepropagation" id="event-stopimmediatepropagation"></a>
    <h2 {...{
      "id": "stopimmediatepropagation"
    }}>{`stopImmediatePropagation()`}</h2>
    <a name="event-stoppropagation" id="event-stoppropagation"></a>
    <h2 {...{
      "id": "stoppropagation"
    }}>{`stopPropagation()`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      